import type { AssetTypesListTableRowActionsProps } from "./asset-types-list-table-row-actions.type";

import AssetTypeForm from "@/features/AssetTypes/AssetTypeForm";
import { useAssetTypeDeleteButton } from "@/modules/asset-type/asset-type-delete-button";
import { useListTableRowActions } from "@/modules/list-table-row-actions";
import ModelDeleteButton from "@/modules/model-delete-button";
import ModelEditButtonLegacy from "@/modules/model-edit-button-legacy";
import ModelViewButton from "@/modules/model-view-button";

const AssetTypesTableRowActions = ({
  assetType,
}: AssetTypesListTableRowActionsProps) => {
  const { closePopover } = useListTableRowActions();
  const { isDeletable, tooltip } = useAssetTypeDeleteButton({
    assetType,
  });
  return (
    <>
      <ModelViewButton
        type="text"
        modelKey="assettype"
        item={assetType}
        onClick={closePopover}
      />
      <ModelEditButtonLegacy
        type="text"
        modelKey="assettype"
        item={assetType}
        component={<AssetTypeForm assetTypeId={assetType.id} />}
        onClick={closePopover}
      />
      <ModelDeleteButton
        type="text"
        modelKey="assettype"
        item={assetType}
        onClick={closePopover}
        disabled={!isDeletable}
        tooltip={tooltip}
        authorizeRender={!isDeletable ? "disabled" : "hidden"}
        hideIcon
      />
    </>
  );
};

export default AssetTypesTableRowActions;
